module.exports = [
  {
    path: `en`,
    label: `English`,
    node_locale: `en`,
  },
  { default: true, path: `pl`, label: `Polski`, node_locale: `pl` },
];
